/**
 * Status dot + a human label / hover hint for the article lifecycle.
 *
 * Keeps the lifecycle vocabulary defined in ONE place — useful for the
 * grid card, the editor subtitle, and the cockpit panels.
 */

const LABELS: Record<string, { label: string; hint: string }> = {
  published: { label: 'Published', hint: 'Lives on the public site. Open as draft to edit + republish.' },
  draft: { label: 'Draft', hint: 'You’re editing this; not visible to readers yet.' },
  pending_review: { label: 'Needs review', hint: 'The factory dropped this in your inbox. Review and publish or send back.' },
  staged: { label: 'Publishing…', hint: 'Committed to GitHub; waiting for the site to rebuild.' },
  deployed: { label: 'Live, indexing…', hint: 'Live on the site; waiting for Google to discover it.' },
  indexed: { label: 'Indexed', hint: 'Live + indexed by Google.' },
  archived: { label: 'Archived', hint: '' },
}

export function statusLabel(status: string): { label: string; hint: string } {
  return LABELS[status] ?? { label: status, hint: '' }
}

export function StatusDot({ status }: { status: string }) {
  return <span className={`status-dot ${status}`} title={statusLabel(status).hint} />
}

export function StatusLegend() {
  return (
    <details style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>
      <summary style={{ cursor: 'pointer', userSelect: 'none' }}>What do the statuses mean?</summary>
      <ul style={{ margin: '0.5rem 0 0', padding: '0 0 0 0', listStyle: 'none' }}>
        {Object.entries(LABELS)
          .filter(([k]) => k !== 'archived')
          .map(([k, v]) => (
            <li key={k} style={{ display: 'flex', gap: '0.5rem', alignItems: 'baseline', padding: '0.2rem 0' }}>
              <span className={`status-dot ${k}`} style={{ marginTop: 4 }} />
              <span>
                <strong style={{ color: 'var(--text)' }}>{v.label}</strong> — {v.hint}
              </span>
            </li>
          ))}
      </ul>
    </details>
  )
}
